module.exports = __webpack_public_path__ + "img/checklist.49c0cc1e.svg";